/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { MILLISECONDS_IN_A_SECOND } from '../../../config';
import { DeviceModel } from '../../../core/device';
import { RootState, useTivoDispatch, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import {
    toastMessageClearAction,
    toastMessageHideAction,
} from '../../../store/toastmessage/toastmessage.actions';

import './ToastMessage.scss';

interface ToastMessageProps {
    type: string;
}

/* eslint-disable react-hooks/exhaustive-deps */
const ToastMessage: FunctionComponent<ToastMessageProps> = ({ type }): JSX.Element => {
    const { isVisible, message } = useTivoSelector((state: RootState) => state.toastMessage);
    const dispatch = useTivoDispatch();

    let toastMessageClass = isVisible ? ' show-toast' : ' hide-toast';
    if (DeviceModel.isWebOsPlatform())
        toastMessageClass = isVisible ? ` enter-${type}` : ` exit-${type}`;

    useEffect(() => {
        if (message) dispatch(toastMessageClearAction());
    }, []);

    useEffect(() => {
        let toastTimerId: NodeJS.Timeout;
        if (isVisible) {
            toastTimerId = setTimeout(() => {
                dispatch(toastMessageHideAction());
            }, 5 * MILLISECONDS_IN_A_SECOND);
        }

        return () => {
            if (toastTimerId) clearTimeout(toastTimerId);
            if (isVisible) dispatch(toastMessageHideAction());
        };
    }, [isVisible, message]);

    return (
        <div className={`toast-container${message.length ? toastMessageClass : ''}`}>
            <div className="message">{message}</div>
        </div>
    );
};

export default ToastMessage;
